// Validadores de cliente compartidos (espejo del backend).
export const TIPOS_DOC = [
  { value: 'DNI',       label: 'DNI' },
  { value: 'CE',        label: 'Carnet de Extranjería' },
  { value: 'PASAPORTE', label: 'Pasaporte' },
  { value: 'RUC',       label: 'RUC' },
];

export function validarDoc(tipo, num) {
  const n = (num || '').trim();
  if (!n) return 'El número de documento es requerido.';
  if (tipo === 'DNI' && !/^\d{8}$/.test(n)) return 'El DNI debe tener 8 dígitos.';
  if (tipo === 'RUC' && !/^\d{11}$/.test(n)) return 'El RUC debe tener 11 dígitos.';
  if (tipo === 'RUC' && !/^(10|15|16|17|20)/.test(n)) return 'El RUC debe iniciar con 10, 15, 16, 17 o 20.';
  if (tipo === 'CE' && (n.length < 9 || n.length > 20)) return 'El CE debe tener entre 9 y 20 caracteres.';
  if (tipo === 'PASAPORTE' && (n.length < 6 || n.length > 20)) return 'El pasaporte debe tener entre 6 y 20 caracteres.';
  if ((tipo === 'CE' || tipo === 'PASAPORTE') && !/^[a-zA-Z0-9]+$/.test(n)) return 'Solo letras y números.';
  if (new Set(n).size === 1) return 'El número no es válido.';
  // DNI: rechazar secuenciales ascendente/descendente (espejo del backend).
  if (tipo === 'DNI') {
    const asc = '0123456789';
    if (asc.includes(n) || asc.split('').reverse().join('').includes(n)) return 'El número no es válido.';
  }
  return null;
}

export function validarEmail(email) {
  if (!email) return 'El correo es requerido.';
  if (!/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(email)) return 'Correo inválido.';
  return null;
}

export function validarCelular(celular) {
  const cel = (celular || '').replace(/[\s\-()]+/g, '');
  if (!cel || cel === '+') return 'El celular es obligatorio.';
  if (!/^\+\d{1,3}\d{6,14}$/.test(cel)) return 'Incluye el código de país (ej. +51) y solo dígitos.';
  return null;
}
